// extracted by mini-css-extract-plugin
export default {"diagramContainer":"DiagramContainer_diagramContainer__lB6a6","containerImage":"DiagramContainer_containerImage__aPBkE","numberLabel":"DiagramContainer_numberLabel__kQjoY"};